import React from 'react'
import './DescriptionBox.css'
const DescriptionBox = () => {
  return (
    <div className="descriptionbox">
        <div className="descriptionboxp-navigator">
            <div className="descriptionbox-nav-box">Description</div>
            <div className="descriptionbox-nav-box fade" >Reviews(112)</div>
        </div>
        <div className="descriptionbox-description">
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae excepturi deleniti, corrupti fugit iste commodi, cum nihil odio laboriosam omnis saepe aliquam vitae esse repellat itaque nemo minima quam hic earum. Aliquam sapiente dicta esse pariatur amet deleniti quis assumenda, suscipit aperiam, voluptatibus adipisci culpa. Consequuntur repudiandae amet aliquid. Qui?</p>
            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eligendi magni modi dicta iste atque id mollitia, saepe aliquid ipsam quod ipsa fugit ratione dolores ipsum expedita quo nemo, dolorum blanditiis, nobis cumque? Nostrum aliquid deserunt quia nisi quaerat. Maxime repellendus pariatur quae sit ea in, quasi inventore numquam distinctio rerum.</p>
            
        </div>
    </div>
  )
}

export default DescriptionBox
